import { Modal, ConfirmationModal } from '@skyline-platform/alchemy';
import './DeletionModal.css';
import PropTypes from 'prop-types';
import { notifications } from '@utils/notifications/index';
import {
  getLogger, camelToHeader, kebabToHeader,
} from '@utils/general';
const logger = getLogger('src.components.DeletionModal');

export const DeletionModal = ({
  customMessage, data, fieldName, handleDelete, trigger, headerIcon,
}) => {
  const formattedFieldName = fieldName.includes('-')
    ? kebabToHeader(fieldName)
    : camelToHeader(fieldName);

  return (<Modal
    className={`delete-${fieldName}-modal`}
    closeIcon
    header={`Delete ${formattedFieldName}`}
    headerIcon={headerIcon ?? 'fa fa-fa-regular fa-waveform'}
    disableBackdropClick
    trigger={trigger}
    // Prevent key actions from propagating to the outer Action Modal component
    onKeyDown={(event) => event.stopPropagation()}
    slots={{
      content: (handleClose) => (
        <ConfirmationModal
          alert
          handleClose={handleClose}
          handleConfirm={async () => {
            try {
              await handleDelete(data);
              notifications.success(`Successfully deleted ${formattedFieldName} ${data.name}.`);
              handleClose();
            } catch {
              const failMessage = `Failed to delete ${formattedFieldName} ${data.name}.`;
              notifications.error(failMessage);
              logger.error(failMessage);
            }
          }}
          content={
            <>
              {customMessage &&
                <div id='customDeleteMsg'>
                  {customMessage}
                </div>
              }
              Are you sure you want to delete <strong>&ldquo;{data.name}&ldquo;</strong>?
            </>

          }
          confirmText={`Yes, delete ${formattedFieldName}`}
          cancelText='Cancel'
        />
      ),
    }}
  />);
};

DeletionModal.propTypes = {
  customMessage: PropTypes.string,
  data: PropTypes.object,
  fieldName: PropTypes.string,
  handleDelete: PropTypes.func,
  headerIcon: PropTypes.string,
  trigger: PropTypes.node,
};